/**
 * Lockstep Platform SDK for TypeScript
 *
 * (c) 2021-2023 Lockstep, Inc.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author     Lockstep Network <support@lockstep.io>
 * @copyright  2021-2023 Lockstep, Inc.
 * @link       https://github.com/Lockstep-Network/lockstep-sdk-typescript
 */
export class GroupAccountsClient {
    /**
     * Internal constructor for this client library
     */
    constructor(client) {
        this.client = client;
    }
    /**
     * Retrieves group account data for the current user.
     *
     */
    retrieveGroupAccountData() {
        const url = `/api/v1/GroupAccounts/me`;
        return this.client.request("get", url, null, null);
    }
    /**
     * Updates a group account that matches the specified id with the requested information.
     *
     * The PATCH method allows you to change specific values on the object while leaving other values alone.  As input you should supply a list of field names and new values.  If you do not provide the name of a field, that field will remain unchanged.  This allows you to ensure that you are only updating the specific fields desired.
     *
     * @param id The unique ID number of the Group Account to retrieve
     * @param body A list of changes to apply to this Group Account
     */
    updateGroupAccount(id, body) {
        const url = `/api/v1/GroupAccounts/${id}`;
        return this.client.request("patch", url, null, body);
    }
}
//# sourceMappingURL=GroupAccountsClient.js.map